import { Link, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { HiOutlineUserCircle, HiOutlineHome } from "react-icons/hi";
import { MdOutlinePassword } from "react-icons/md";
import { logo } from "../../../assets";
import { defaultPicture } from "../../../utils";

const CustomerPcMenu = () => {
  const userInfo = useSelector((state) => state.userInfo);

  return (
    <div className="lg:flex hidden">
      <div
        className="ml-[-100%] fixed z-10 top-0 pb-3 px-6 w-full flex flex-col 
        justify-between h-screen border-l border-yellow-200 bg-[#171d3f] 
        transition duration-300 2xl:w-[15%] xl:w-[25%] lg:w-[30%] md:w-4/12 sm:w-6/12"
      >
        <div>
          {/* Logo */}
          <div className="flex justify-center py-4">
            <Link to="/Public/Home" title="home">
              <img
                src={logo}
                width={70}
                className="rounded-full bg-cover border-2 border-yellow-400"
                alt="Website Logo"
              />
            </Link>
          </div>

          {/* Profile Picture */}
          <span className="w-full">
            <img
              src={defaultPicture}
              alt="User_Profile"
              width={120}
              className="m-auto text-gray-200 rounded-full object-cover border-2 border-yellow-200"
            />
          </span>

          {/* Profile Info */}
          <div className="mt-8 text-center">
            <h5 className="hidden mt-4 text-xl font-semibold text-white lg:block">
              {userInfo[0]?.firstname} {userInfo[0]?.lastname}
            </h5>
            <span className="hidden text-yellow-600 lg:block">کاربر</span>
          </div>

          {/* Navigation */}
          <ul className="space-y-3 tracking-wide mt-8">
            <li>
              <NavLink
                to="/Customer/Profile"
                className={({ isActive }) =>
                  isActive
                    ? "relative px-4 py-3 flex items-center space-x-4 bg-[#173372] rounded-xl text-white cursor-pointer border border-yellow-300"
                    : "relative px-4 py-3 flex items-center space-x-4 rounded-xl text-white hover:bg-[#153477] cursor-pointer"
                }
              >
                <HiOutlineUserCircle
                  size={25}
                  className="text-yellow-600 ml-2"
                />
                <span className="-mr-1 font-medium">پروفایل</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Customer/Change-Password"
                className={({ isActive }) =>
                  isActive
                    ? "relative px-4 py-3 flex items-center space-x-4 bg-[#173372] rounded-xl text-white cursor-pointer border border-yellow-300"
                    : "relative px-4 py-3 flex items-center space-x-4 rounded-xl text-white hover:bg-[#153477] cursor-pointer"
                }
              >
                <MdOutlinePassword size={25} className="text-yellow-600 ml-2" />
                <span>تغییر رمز عبور</span>
              </NavLink>
            </li>
          </ul>
        </div>

        {/* Home Button */}
        <div className="px-6 -mx-6 pt-4 flex justify-between items-center border-t border-yellow-200">
          <Link to="/Public/Home">
            <button className="px-4 py-3 flex items-center space-x-4 rounded-md text-white hover:text-yellow-600">
              <HiOutlineHome size={25} className="ml-2 text-yellow-600" />
              <span>صفحه اصلی</span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CustomerPcMenu;
